// src/components/Dashboard/Topbar.jsx
import React, { useState } from "react";
import {
    Toolbar,
    Typography,
    Avatar,
    IconButton,
    Menu,
    MenuItem,
    Divider,
    Tooltip,
} from "@mui/material";

const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0];
    return parts[0][0] + parts[1][0];
};

const Topbar = ({ user, wsStatus, onEditProfile, onLogout }) => {
    const [anchorElUser, setAnchorElUser] = useState(null);

    const getStatusColor = (status) => {
        switch (status) {
            case "connected": return "#4caf50";     // green
            case "reconnecting": return "#ff9800";  // amber
            case "disconnected": return "#f44336";  // red
            default: return "#9e9e9e";              // default grey
        }
    };


    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <Toolbar
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                mb: 2,
                gap: 2,
            }}
        >
            <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                        sx={{
                            bgcolor: getStatusColor(wsStatus),
                            color: "#fff",
                        }}
                    >{getInitials(user.full_name).toUpperCase()}</Avatar>
                </IconButton>
            </Tooltip>

            <Typography
                variant="h6"
                component="div"
                sx={{ cursor: "pointer" }}
                onClick={handleOpenUserMenu}
            >
                {user.full_name} ({user.role})
            </Typography>

            <Menu
                sx={{ mt: "45px" }}
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <MenuItem
                    onClick={() => {
                        onEditProfile();
                        handleCloseUserMenu();
                    }}
                >
                    Edit Profile
                </MenuItem>
                <Divider />
                <MenuItem
                    onClick={() => {
                        onLogout();
                        handleCloseUserMenu();
                    }}
                >
                    Logout
                </MenuItem>
            </Menu>
        </Toolbar>
    );
};

export default Topbar;
